import styled from "styled-components";

export const ContentWrapper = styled.div`
  width: 100%;
  padding: 2rem;
`;
